import { FC, useMemo } from 'react'
import Link from 'next/link'
import Image from 'next/image'
import dayjs from 'dayjs'
import classNames from 'classnames'
import Dotdotdot from 'react-dotdotdot'
import styles from './HighlightedArticle.module.scss'
import { HighlightedArticleProps as Props } from './types'
import Author from 'components/author/Author'
import Tag from 'components/tag/Tag'
import { routes } from 'utils/routes'

const HighlightedArticle: FC<Props> = ({ article }) => {
  const destination = useMemo(
    () => routes(article.locale, '', [article?.category?.slug, article?.subCategory?.slug, article?.slug]).encyclopediaArticle,
    [article.locale, article.category.slug, article.subCategory.slug, article.slug]
  )

  return (
    <section className={classNames('section', styles.section)}>
      <div className="container">
        <div className={styles['highlighted-article']}>
          <Link href={destination}>
            <a className={styles.article}>
              {article.thumbnail && (
                <figure className={styles['thumbnail-wrapper']}>
                  <Image layout="fill" objectFit="cover" src={article.thumbnail} className={styles.thumbnail} />
                </figure>
              )}
              <div className={styles.content}>
                {article.category && <Tag name={article.category?.title} color={article.category?.color} className={styles.tag} />}
                <h2 className={styles.title}>{article.title}</h2>
                <Dotdotdot clamp={6} className={styles.description}>
                  {article.description}
                </Dotdotdot>
                <Author
                  date={dayjs(article.publishedAt).format('DD/MM/YYYY')}
                  name={article?.author?.firstName ? `${article.author.firstName}` : ''}
                  image={article?.author?.avatar}
                />
              </div>
            </a>
          </Link>
        </div>
      </div>
    </section>
  )
}

export default HighlightedArticle
